import { useQuery } from "@tanstack/react-query";
import { Transaction } from "../../services/services";
import ResponsiveDataList from "../../components/ResponsiveDataList/ResponsiveDataList";
import { useState } from "react";
import PersianDate from "../../components/PersianDate/PersianDate";

const transactionTypeMap = {
  0: "هیچکدام",
  1: "پاداش",
  2: "تبدیل",
  3: "قرعه‌کشی",
  4: "خرید محصول",
  5: "سایر",
  6: "نصب تابلو",
  7: "معرف",
  8: "گردونه شانس",
  9: "لغو سفارش",
  10: "سیستمی",
  11: "تبدیل سکه به شانس",
  12: "نبدیل سکه به شانس استفاده شده ",
  13: "رسیدن به هدف",
  14: "ps5",
  15: "موتور",
  16: "سفر",
  17: "هدف یلدایی",
  18: "زاویه الفا",
  19: "هدیه نقدی",
  20: "ظرفیت کابین",
  21: "شتاب سنج",
  22: "جایزه کمپین",
  23: "نصب تابلو در کمپین",
};

const HistoryTransaction = ({ id, isMobile }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(12);

  const formatAmount = (amount) => {
    if (amount == null) return "";

    const num = Number(amount);
    const formatted = num < 0 ? `-${Math.abs(num)}` : `${num}`;

    return (
      <span style={{ direction: "ltr", display: "inline-block" }}>
        {formatted}
      </span>
    );
  };

  const { data } = useQuery({
    queryKey: ["Transaction", id, pageNumber, pageSize],
    queryFn: () =>
      Transaction({
        userId: id,
        pageNumber,
        pageSize,
      }),
    select: (res) => res,
    staleTime: 60 * 60000,
    retry: false,
    enabled: !!id,
  });

  const purchaseHistory = (data?.items ?? []).filter(
    (item) => item?.currency === 1 && item?.amount >= 0
  );
  const totalCount = data?.totalCount ?? 0;
  const columns = [
    {
      field: "time",
      body: (rowData) => <PersianDate date={rowData?.time} />,
      header: "تاریخ",
      style: { textAlign: "right" },
    },
    {
      field: "description",
      body: (rowData) => <span>{transactionTypeMap[rowData?.type]}</span>,
      header: "علت دریافت سکه",
      style: { textAlign: "right" },
    },
    {
      field: "amount",
      header: "تعداد سکه دریافت شده",
      style: { textAlign: "right" },
    },
  ];

  const itemTemplate = (item) => (
    <div
      key={item.ID}
      className="rounded shadow-sm mb-3 p-3"
      style={{ backgroundColor: "#f9f9f9", border: "1px solid #eee" }}
    >
      <div className="mb-1">
        <strong>توضیحات:</strong> {item.description}
      </div>
      <div className="mb-1">
        <strong>مبلغ:</strong> {formatAmount(item.amount)}
      </div>
      <div className="mb-1">
        <strong>وضعیت:</strong> {transactionTypeMap[item.type]}
      </div>
    </div>
  );

  return (
    <div className="card mt-4" style={isMobile ? {} : { height: "650px" }}>
      <h5> تاریخچه دریافت سکه </h5>

      {purchaseHistory?.length > 0 ? (
        <div className="background-dataTable">
          <ResponsiveDataList
            data={purchaseHistory}
            columns={columns}
            itemTemplate={itemTemplate}
            dataViewHeader={<></>}
            className="farsi-monospace-digit"
            rows={pageSize}
            rowsPerPageOptions={[2, 5, 10]}
            pageNumber={pageNumber}
            totalCount={totalCount}
            onPageChange={({ pageNumber: p, pageSize: s }) => {
              setPageNumber(p);
              setPageSize(s);
            }}
          />
        </div>
      ) : (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "rgb(100, 100, 100)",
          }}
        >
          <h5>موردی یافت نشد !</h5>
        </div>
      )}
    </div>
  );
};

export default HistoryTransaction;
